import { render, staticRenderFns } from "./ve-table-objective-pos.vue?vue&type=template&id=62da9cbc"
import script from "./ve-table-objective-pos.vue?vue&type=script&lang=js"
export * from "./ve-table-objective-pos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports